module.exports = function(cb) {
	require.ensure([], function(require) {
		cb(require("!!../../../../../../node_modules/happypack/loader.js?id=jsx!./NewAddressView.js"));
	}, "NewAddressView");
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/bundle-loader?lazy&name=NewAddressView!./src/pages/Shop/Member/Address/NewAddress/NewAddressView.js
// module id = 1483
// module chunks = 418